<template>
<div class="flowNodeDtl_box">
    <el-collapse v-model="activeNames" style="width: 100%;" v-if="!nodeId || (nodeId && nodeDtlSet[nodeDtl.type])">
        <el-collapse-item v-for="item,index of nodeDtlSet[nodeDtl.type || 'FLOW']" :key="index" :name="index">
            <template #title>
                <div class="moduleBox_title">
                    <img style="height:14px; margin-right: 6px;" :src="require('@img/bizFlow/treeIcon'+ nodeDtlFormSet[item].linkType +'.png')" alt="">
                    {{nodeDtlFormSet[item].name}}
                </div>
            </template>
            <div  class="moduleBox_list">
                <el-collapse v-model="activeObj[item]" style="width: 100%;" v-if="flowVerDtl && flowVerDtl['bfv_id'] && elementSet.eleObj[nodeDtlFormSet[item].linkType] && Object.keys(elementSet.eleObj[nodeDtlFormSet[item].linkType]).length > 0 && nodeDtlFormSet[item].mode == 'element'">
                    <el-collapse-item v-for="zitem,zindex of elementSet.eleObj[nodeDtlFormSet[item].linkType]" :key="zindex" :name="zindex">
                        <template #title>
                            <div class="moduleBox_title">
                                {{zitem[keyObj[nodeDtlFormSet[item].linkType]['dataKey'] + '_name']}}
                            </div>
                        </template>
                        <div  class="moduleBox_desc">
                            <p v-for="fitem,findex of nodeDtlFormSet[item].fldsList || []" :key="findex">
                                <span>{{ fitem.title }}</span>：
                                <span v-if="fitem.type == 'text'">{{ zitem[fitem.id] || '-' }}</span>
                                <span v-if="fitem.type == 'api'">{{ zitem[fitem.showId] || '-' }}</span>
                                <span v-if="fitem.type == 'textarea'">{{ zitem[fitem.id] || '-' }}</span>
                                <span v-if="fitem.type == 'json'">{{JSON.parse(zitem[fitem.id])[fitem.key] || '-'}} </span>
                                <span v-if="fitem.type == 'select'">{{fitem.valueObj[zitem[fitem.id]]}} </span>
                            </p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div class="moduleBox_list" v-else-if="flowVerDtl && flowVerDtl['bfv_id'] && elementSet.eleObj[nodeDtlFormSet[item].linkType] && Object.keys(elementSet.eleObj[nodeDtlFormSet[item].linkType]).length > 0 && nodeDtlFormSet[item].mode == 'file'">
                    <fileNav v-model="elementSet.eleObj[nodeDtlFormSet[item].linkType]" :dtlApi="$api.newBpa.queryBfInstitutionDtl" :auth="'READONLY'" :mode="'objectList'" :keyEleType="nodeDtlFormSet[item].linkType" :dataKey="keyObj[nodeDtlFormSet[item].linkType]['dataKey']"></fileNav>
                </div>
                <el-collapse v-model="activeObj[item]" style="width: 100%;" v-else-if="flowVerDtl && flowVerDtl['bfv_id'] && elementSet.eleObj[nodeDtlFormSet[item].linkType] && Object.keys(elementSet.eleObj[nodeDtlFormSet[item].linkType]).length > 0 && nodeDtlFormSet[item].mode == 'owner'">
                    <el-collapse-item v-for="zitem,zindex of elementSet.eleObj[14]" :key="zindex" :name="zindex">
                        <template #title>
                            <div class="moduleBox_title">
                                <img src="@img/orgmgt/dep.png" alt="">
                                {{zitem[keyObj[14]['dataKey'] + '_name']}}
                            </div>
                        </template>
                        <div  class="moduleBox_desc">
                            <p v-for="fitem,findex of nodeDtlFormSet[item]['fldsList14'] || []" :key="findex">
                                <span>{{ fitem.title }}</span>：
                                <span v-if="fitem.type == 'text'">{{ zitem[fitem.id] || '-' }}</span>
                                <span v-if="fitem.type == 'jsonList'">{{ JSON.parse(zitem[fitem.id] || '[]').reduce((res = '',xitem)=>{res += (res ? '、':'') + xitem[fitem['key']];return res;},'') || '-' }}</span>
                            </p>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item v-for="zitem,zindex of elementSet.eleObj[13]" :key="zindex" :name="zindex">
                        <template #title>
                            <div class="moduleBox_title">
                                <img src="@img/orgmgt/post.png" alt="">
                                {{zitem[keyObj[13]['dataKey'] + '_name']}}
                            </div>
                        </template>
                        <div  class="moduleBox_desc">
                            <p v-for="fitem,findex of nodeDtlFormSet[item]['fldsList13'] || []" :key="findex">
                                <span>{{ fitem.title }}</span>：
                                <span v-if="fitem.type == 'text'">{{ zitem[fitem.id] || '-' }}</span>
                                <span v-if="fitem.type == 'jsonList'">{{ JSON.parse(zitem[fitem.id] || '[]').reduce((res = '',xitem)=>{res += (res ? '、':'') + xitem[fitem['key']];return res;},'') || '-' }}</span>
                            </p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <div  class="moduleBox_desc" v-else-if="flowVerDtl && nodeDtlFormSet[item].mode == 'text' && nodeDtlFormSet[item].from == 'node'">
                    {{ nodeDtl[nodeDtlFormSet[item].key] }}
                </div>
                <div  class="moduleBox_desc" v-else-if="flowVerDtl && nodeDtlFormSet[item].mode == 'text' && nodeDtlFormSet[item].from != 'node'">
                    {{ flowVerDtl[nodeDtlFormSet[item].key] }}
                </div>
                <div  class="moduleBox_desc" v-else style="color:#909099;">暂无信息</div>
            </div>
        </el-collapse-item>
        <el-collapse-item name="FILE">
            <template #title>
                <div class="moduleBox_title">
                    <i class="iconfont icon-a-9"></i>
                    文件
                </div>
            </template>
            <div class="moduleBox_list">
                <fileNav v-model="nodeFile" :auth="'READONLY'"></fileNav>
            </div>
        </el-collapse-item>
    </el-collapse>
    <div  class="moduleBox_desc" v-else>
        <el-empty description="暂无数据" :image-size="100"/>
    </div>
</div>
</template>
    
  <script>
  import fileNav from "../flowStructGraph/common/fileNav.vue";
  export default {
      components:{
        fileNav
      },
      props:{
        showDtl:{
            type: Boolean,
            default: function() {
                return false;
            }
        }, 
        flowVerDtl:{
            type: Object,
            default: function() {
                return {};
            }
        }, 
        nodeDtl:{
            type: Object,
            default: function() {
                return {};
            }
        }, 
        nodeId:{
            type: String,
            default: function() {
                return '';
            }
        }, 
      },
      watch:{
        showDtl: {
            handler() {
                if(this.showDtl){
                    this.activeNames = 'DTL'
                }
                else{
                    this.activeNames = '0'
                }
            },
            deep: true,
            immediate: true
        }, 
        flowVerDtl: {
            handler() {
                if(this.flowVerDtl && Object.keys(this.flowVerDtl).length > 0){
                    this.copyFlowVer = this.flowVerDtl
                    this.queryBsgNodeListByIds()
                }
            },
            deep: true,
            immediate: true
        }, 
      },
    data() {
      return {
        activeNames:'',
        activeObj:{},
        copyFlowVer:{},
        nodeFile:[],
        nodeDtlSet:{
            'FLOW':['nodeOwners','nodeRules','nodeRisks','nodeAuths','nodeCapas','nodeNouns','nodeIts','nodeKpis',],
            'FLOWACTION':['nodePosts','nodeRules','nodeRisks','nodeAuths','nodeCapas','nodeNouns','nodeIts','nodeKpis','elapsedTimeNode'],
            'BPMTASK':['nodePosts','nodeRules','nodeRisks','nodeAuths','nodeCapas','nodeNouns','nodeIts','nodeKpis',],
            'CONTROL':['nodePosts','nodeRules','nodeRisks','nodeAuths','nodeCapas','nodeNouns','nodeIts','nodeKpis',],
        },
        nodeDtlFormSet:{
            nodeOwners:{
                type:'link',
                name:'流程参与者',
                linkType:13,
                nodeType:'POST',
                mode:'owner',
                fldsList13:[
                    {
                        title:'岗位职责',
                        id:'bp_duty',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'岗位要求',
                        id:'bp_require',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'关联组织架构的岗位',
                        id:'bd_relateDep',
                        key:'post_name',
                        width:null,
                        require:true,
                        type:'jsonList'
                    },
                ],
                fldsList14:[
                    {
                        title:'部门职责',
                        id:'bd_duty',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'关联组织架构的部门',
                        id:'bd_relateDep',
                        key:'dep_name',
                        width:null,
                        require:true,
                        type:'jsonList'
                    },
                ],
            },
            nodePosts:{
                type:'link',
                name:'责任者',
                linkType:13,
                nodeType:'POST',
                mode:'owner',
                fldsList13:[
                    {
                        title:'岗位职责',
                        id:'bp_duty',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'岗位要求',
                        id:'bp_require',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'关联组织架构的岗位',
                        id:'bd_relateDep',
                        key:'post_name',
                        width:null,
                        require:true,
                        type:'jsonList'
                    },
                ],
                fldsList14:[
                    {
                        title:'部门职责',
                        id:'bd_duty',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'关联组织架构的部门',
                        id:'bd_relateDep',
                        key:'dep_name',
                        width:null,
                        require:true,
                        type:'jsonList'
                    },
                ],
            },
            nodeIts:{
                type:'link',
                name:'IT系统',
                key:'bsg_node_itSys',
                linkType:9,
                nodeType:'APPSYS',
                fldsList:[
                    {
                        title:'系统描述',
                        id:'bfit_desc',
                        width:null,
                        require:true,
                        type:'textarea'
                    },
                ],
                mode:'element',
            },
            nodeRisks:{
                type:'link',
                key:'bsg_node_risk',
                name:'风险',
                linkType:2,
                nodeType:'RISK',
                fldsList:[
                    {
                        title:'风险名称',
                        id:'bfr_name',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'控制类型',
                        id:'bfr_controlType',
                        width:null,
                        type:'select',
                        require:true,
                        valueObj:{
                            10:'预防性',
                            11:'发现性',
                        },
                    },
                    {
                        title:'控制频率',
                        id:'bfr_frequency',
                        width:null,
                        type:'text'
                    },
                    {
                        title:'控制措施',
                        id:'bfr_ctlMeasures',
                        width:null,
                        type:'textarea'
                    },
                    {
                        title:'风险描述',
                        id:'bfr_desc',
                        width:null,
                        type:'textarea'
                    },
                ],
                mode:'element'
            },
            nodeRules:{
                type:'link',
                key:'bsg_node_institution',
                name:'制度',
                linkType:11,
                nodeType:'SYSTEM',
                mode:'file'
            },
            nodeKpis:{
                type:'link',
                key:'bsg_node_index',
                name:'绩效',
                linkType:1,
                nodeType:'INDEX',
                fldsList:[
                    {
                        title:'指标名称',
                        id:'bin_name',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'指标维度',
                        id:'bin_dimension',
                        key:'indexDim',
                        require:true,
                        width:null,
                        type:'select',
                        valueObj:{
                            10:'主观部分',
                            20:'客观部分',
                        },
                    },
                    {
                        title:'目标值',
                        id:'bin_goal',
                        width:null,
                        type:'text'
                    },
                    {
                        title:'评分标准',
                        id:'bin_standard',
                        width:null,
                        type:'textarea'
                    },
                    {
                        title:'评分区间',
                        id:'bin_section',
                        width:null,
                        type:'text'
                    },
                    {
                        title:'指标说明',
                        id:'bin_desc',
                        width:null,
                        type:'textarea'
                    },
                ],
                mode:'element'
            },
            nodeCapas:{
                type:'link',
                key:'bsg_node_capaSys',
                name:'能力体系',
                linkType:10,
                nodeType:'INDEX',
                fldsList:[
                    {
                        title:'能力名称',
                        id:'bfcs_name',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'能力类型',
                        id:'bfcst_id',
                        showId:'bfcst_name',
                        width:null,
                        onlyShow:true,
                        require:true,
                        type:'api',
                        flds:[
                            {
                                title:'能力类型名称',
                                id:'bfcst_name',
                                require:true,
                                width:null,
                                type:'text'
                            },
                            {
                                title:'能力类型描述',
                                id:'bfcst_desc',
                                require:false,
                                width:null,
                                type:'textarea'
                            },
                        ],
                        apiLink:{
                            queryData:this.$api.newBpa.queryBfCapaSysTypeList,
                            addData:this.$api.newBpa.addBfCapaSysType,
                            updateData:this.$api.newBpa.updateBfCapaSysType,
                            delData:this.$api.newBpa.delBfCapaSysType,
                        }
                    },
                    {
                        title:'能力等级',
                        id:'bfcs_level',
                        width:null,
                        type:'select',
                        require:true,
                        valueObj:{
                            1:'等级一',
                            2:'等级二',
                            3:'等级三',
                            4:'等级四',
                            5:'等级五',
                        },
                    },
                    {
                        title:'能力描述',
                        id:'bfcs_desc',
                        width:null,
                        type:'textarea'
                    },
                ],
                mode:'element'
            },
            nodeAuths:{
                type:'link',
                key:'bsg_node_auth',
                name:'授权',
                linkType:0,
                nodeType:'INDEX',
                fldsList:[
                    {
                        title:'权限名称',
                        id:'bfa_name',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'权限描述',
                        id:'bfa_desc',
                        width:null,
                        type:'textarea'
                    },
                ],
                mode:'element'
            },
            nodeNouns:{
                type:'link',
                key:'bsg_node_nounTerm',
                name:'名词术语',
                linkType:12,
                nodeType:'INDEX',
                fldsList:[
                    {
                        title:'名词名称',
                        id:'bfnt_name',
                        width:null,
                        require:true,
                        type:'text'
                    },
                    {
                        title:'名词解释',
                        id:'bfnt_explain',
                        width:null,
                        type:'textarea'
                    },
                    {
                        title:'备注',
                        id:'bfnt_remark',
                        width:null,
                        type:'textarea'
                    },
                ],
                mode:'element'
            },
            elapsedTime:{
                type:'text',
                name:'耗时',
                linkType:'Time',
                key:'bfv_elapsedTime',
                mode:'text'
            },
            elapsedTimeNode:{
                type:'text',
                name:'耗时',
                linkType:'Time',
                key:'bsg_node_elapsedTime',
                mode:'text',
                from:'node',
            },
            nodeFile:{
                type:'file',
                name:'相关文档',
                mode:'file'
            },
        },
        elementSet:{
            eleObj:{},
        },
        nodeInfoSet:{
            'ALL':['formType','riskName','riskDesc','indexDim','indexStandard','indexGoal','indexSection','nodeSeq','nodeInput','nodeOutput',],
            'FORM':['formType'],
            'RISK':['riskName','riskDesc'],
            'INDEX':['indexDim','indexStandard','indexGoal','indexSection'],
            'FLOWACTION':['nodeSeq','nodeInput','nodeOutput'],
            'BPMTASK':['nodeSeq','nodeInput','nodeOutput'],
            'CONTROL':['nodeSeq','nodeInput','nodeOutput'],
        },
        keyObj:{
            0:{
                key:'bfag',
                dataKey:'bfa',
            },
            1:{
                key:'big',
                dataKey:'bin',
            },
            2:{
                key:'bfrg',
                dataKey:'bfr',
            },
            5:{
                key:'bfpg',
                dataKey:'bfp',
            },
            9:{
                key:'bfitg',
                dataKey:'bfit',
            },
            10:{
                key:'bfcsg',
                dataKey:'bfcs',
            },
            11:{
                key:'bfig',
                dataKey:'bfi',
            },
            12:{
                key:'bfntg',
                dataKey:'bfnt',
            },
            13:{
                key:'bd',
                dataKey:'bp',
            },
            14:{
                key:'bd',
                dataKey:'bd',
            },
        },
      }
    },
    created() {
      
    },
    mounted() {
        
    },
    methods: {
        queryBsgNodeListByIds(){
            let params = {}
            if(this.flowVerDtl['bfv_bfId']){
                params = {
                    'bf_id':this.flowVerDtl['bfv_bfId'],
                    'bfv_id':this.flowVerDtl['bfv_id'],
                }
            }
            if(this.nodeId){
                params['nodeId'] = this.nodeId
            }
            // this.getDepDataFunc().then(dRes => {
                this.getPostDataFunc().then(fRes => {
                    this.$http.post(this.$api.newBpa.queryKeyEles, {
                        ...params,
                    }).then(res => {
                        let obj = {}
                        let keyObj = {
                            "bfITSys": 9,
                            "bfCapaSys": 10,
                            "bfIndex": 1,
                            "bfInstitution":11,
                            "bfNounTerm": 12,
                            "bfFile": 5,
                            "bfAuth": 0,
                            "bfRisk": 2,
                        }
                        for(let key in res.payload){
                            obj[keyObj[key]] =  (res.payload[key] || []).reduce((oRes = {},oitem)=>{
                                oRes[oitem[this.keyObj[keyObj[key]]['dataKey'] + '_id']] = oitem
                                return oRes
                            },{})
                        }
                        obj[13] =  {
                                ...obj[13] || {},
                                ...(fRes.payload || []).reduce((oRes = {},oitem)=>{
                                oRes[oitem[this.keyObj[13]['dataKey'] + '_id']] = oitem
                                return oRes
                            },{})
                        }
                        // if(dRes){
                        //     obj[14] =  {
                        //         ...obj[14] || {},
                        //         ...(dRes.payload || []).reduce((oRes = {},oitem)=>{
                        //         oRes[oitem[this.keyObj[14]['dataKey'] + '_id']] = oitem
                        //         return oRes
                        //     },{})
                        //     }
                        // }
                        this.elementSet.eleObj = obj
                        this.nodeFile = (res.payload['bfFile'] || []).reduce((dres = [],citem)=>{
                            dres.push(citem.bfp_id)
                            return dres
                        },[])
                    })
                })
            // })
        },
        getDepDataFunc(){
            return new Promise((resolve)=>{
                if(this.nodeId){
                    return resolve(null)
                }
                let depList = this.flowVerDtl['bfv_deps'] || []
                this.$http.post(this.$api.newBpa.queryBfDepList, {// 岗位等回显
                    'bdIds':depList,
                }).then(dRes => {
                    resolve(dRes)
                })
            })
        },
        getPostDataFunc(){
            return new Promise((resolve)=>{
                if(this.nodeId){
                    let postList = this.nodeDtl['nodePosts'] || []
                    if(postList.length > 0){
                        this.$http.post(this.$api.newBpa.queryBfPostList, {// 岗位等回显
                            'bpIds':postList,
                        }).then(fRes => {
                            resolve(fRes)
                        })
                    }
                    else{
                        resolve({payload:[]})
                    }
                }
                else{
                    this.$http.post(this.$api.newBpa.queryNodesAttr, {// 岗位等回显
                        'bf_id':this.flowVerDtl['bfv_bfId'],
                        'bv_id':this.flowVerDtl['bfv_id'],
                    }).then(res => {
                        let postList = []
                        for(let item of res.payload || []){
                            let obj = JSON.parse(item || '{}')
                            let pList = obj['nodePosts'] || []
                            postList = postList.concat(pList)
                        }
                        if(postList.length > 0){
                            this.$http.post(this.$api.newBpa.queryBfPostList, {// 岗位等回显
                                'bpIds':postList,
                            }).then(fRes => {
                                resolve(fRes)
                            })
                        }
                        else{
                            resolve({payload:[]})
                        }
                    })
                    
                }
            })
        },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .flowNodeDtl_box{
    :deep(.el-collapse-item__header){
        --el-collapse-header-height:40px;
        --el-collapse-header-bg-color:#F7F8FA;
        background:#F7F8FA;
        border-bottom: 1px solid #ebeef5;
        border-top: none;
        font-size: 13px;
    }
    :deep(.el-collapse-item__wrap){
        border-bottom: none;
    }
    :deep(.el-collapse-item__content){
        padding-bottom: 25px;
    }
    .moduleBox_list{
        :deep(.el-collapse-item__header){
            --el-collapse-header-bg-color:#fff;
            background:#fff;
        }
        :deep(.el-collapse-item__wrap){
            border-bottom: 1px solid #ebeef5;
        }
        :deep(.el-collapse-item__header.is-active){
            border-bottom-color: #ebeef5;
        }
    }
    .moduleBox_title{
        padding:0 16px;
        display: flex;
        align-items: center;

        i{
            margin-right: 6px;
            font-size: 14px;
            color: #a5a6af;
        }
        img{
            height: 16px;
            margin-right: 6px;
        }
    }
    .moduleBox_desc{
        padding: 15px;
        padding-bottom: 0;
        p{
            white-space: pre-wrap;
            word-break: break-all;
        }
    }
    .flowNodeDtl_tblContent{
        // height: calc(100% - 40px);
        height: 100%;
        overflow: auto;
        box-sizing: border-box;
        padding:8px 15px;
        .flowNodeDtl_infoTitle{
            margin-bottom: 6px;
        }
        .flowNodeDtl_infoInput{
            margin-bottom: 10px;
            :deep(.el-textarea__inner){
                cursor: text;
                color: #303033;
                --el-disabled-bg-color:#F0F0F5;
            }
            :deep(.el-input__wrapper){
                --el-disabled-bg-color:#F0F0F5;
            }
            :deep(.el-input),:deep(.el-input__inner){
                cursor: text;
                color: #303033;
            }
        }
    }
  }
  </style>
  